import {
  BookingResourceBooking,
  BookResourceScreenDocument,
  ProfileInput,
} from '@/graphql/generated-types';
import { apolloClient } from '@/utils/apollo';
import SentryGraphQLError from '@/utils/exceptions/SentryGraphQLError';

const bookResourceScreen = async (
  participants: ProfileInput[],
  booking: BookingResourceBooking
) => {
  const response = await apolloClient.mutate({
    mutation: BookResourceScreenDocument,
    variables: {
      participants,
      booking,
    },
    errorPolicy: 'all',
  });

  if (response.data?.booking?.bookResourceScreen?.success) {
    return response.data.booking.bookResourceScreen;
  }

  throw new SentryGraphQLError(`api.booking.bookResourceScreen`, response);
};

export default {
  bookResourceScreen,
};
